export default {
    'the-role': 'الدور',
    "add-new-role": "إضافة دور جديد",
    "permissions": "الصلاحيات",
    "please-select-a-role": "رجاءاَ قم باختيار دور وظيفي",
    "read": "قراءة",
    "action": "إضافة / تعديل",
    "nothing": "لا شيء",
    'this-role': "هذا الدور"
}